import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransfers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9780_143713)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.25 13.8751L9.625 18.0001V15.7667C3.90144 15.736 2.35508 10.1414 2.35059 10.1251C2.36148 10.1354 5.24331 12.8715 9.625 12.4512V9.75006L15.25 13.8751ZM8.125 2.23346C13.8568 2.2642 15.3994 7.87506 15.3994 7.87506C15.3994 7.87506 12.5149 5.12785 8.125 5.54889V8.25006L2.5 4.12506L8.125 6.10352e-05V2.23346Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9780_143713",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "currentColor",
			transform: "translate(0.25 6.10352e-05)"
		})
	}) })]
});
export default SvgTransfers;
